import { render, staticRenderFns } from "./DonationReasonModal.vue?vue&type=template&id=789b0273&scoped=true&"
import script from "./DonationReasonModal.vue?vue&type=script&lang=js&"
export * from "./DonationReasonModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "789b0273",
  null
  
)

export default component.exports